export var flagIconTheme = {
  baseStyle: {
    display: 'inline-flex',
    // This makes sure the icon is vertically aligned to the text next to it.
    verticalAlign: 'text-bottom',
    _disabled: {
      opacity: '0.35'
    }
  }
};
//# sourceMappingURL=FlagIcon.theme.js.map